import { routeList } from '@/router/helpers/routes'
import { ACCOUNT_MAIN_CURRENCY, ACCOUNT_TYPES, ACCOUNT_FAMILIES } from '@/assets/constants/accounts'

/* URL for curresponding Account Types */
export const getAccountRoute = (accountType) => {
	const accountsRoutes = {}

	return accountsRoutes[accountType]
}

/* Route Name for curresponding Account Types */
export const getAccountRouteName = (accountType) => {
	const accountsRoutesNames = {
		DO: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		CA: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		CB: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		CI: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		DWALLET: routeList.ACCOUNTS_BALANCES_AND_MOVEMENTS_NAME,
		CRR: routeList.CREDITS_MY_CREDITS_NAME,
		C1: routeList.CREDITS_MY_CREDITS_NAME,
		C2: routeList.CREDITS_MY_CREDITS_NAME,
		CRF: routeList.CREDITS_MY_CREDITS_NAME,
		CCO: routeList.CREDITS_MY_CREDITS_NAME,
		DP: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME,
		CC: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME,
		CD: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME,
		CE: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME,
		CH: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME
	}
	return accountsRoutesNames[accountType]
}

/* CA ("Conta a Ordem Particular"), CB ("Conta a Empresas") and CD ("Conta BAI Jovem") are all
demand-deposit accounts and the bank confirmed they must be available in every origin-account
dropdown, for consultations and for transactions alike (issue #118957, following #118617 which
had allowed CD on the consultation routes only). */
export const accountsTypesForOperations = {
	HOME: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	HOME_MOBILE: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	ACCOUNTS_BALANCES_AND_MOVEMENTS: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	ACCOUNTS_DETAILS: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	PAYMENTS_SISP_REFERENCE: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	PAYMENTS_SISP_RECHARGE: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	SAVINGS_PRODUCTS_CONSTITUTE: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	TRANSFERS_NACIONAL: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	TRANSFERS_INTERNATIONAL: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	CARDS_CHARGE_PREPAID_TOPUP: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
    CARDS_CHARGE_PREPAID: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	CARDS_REQUEST_CARD_GENERIC: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI],
	CREDITS_MY_CREDITS: [ACCOUNT_TYPES.CR],
	SUPPORT_REQUESTS: [ACCOUNT_TYPES.CA, ACCOUNT_TYPES.CB, ACCOUNT_TYPES.CD, ACCOUNT_TYPES.CI]
	/* Still missing a lot of routeNames here */
}

export const accountsComponentExcludedForOperations = {
	/* Still missing a lot of routeNames here */
}

export const accountsFamiliesForOperations = {
	CREDIT_CONSULT: [ACCOUNT_FAMILIES.liabilities]
}

export const accountsCurrenciesOperation = {
	/* Still missing a lot of routeNames here */
	CARDS_CHARGE_PREPAID: [ACCOUNT_MAIN_CURRENCY]
}

/*
ACCOUNT_NATURES = ['10', '22', '55']
*/

export const accountsNaturesOperation = {}

/*
ACCOUNT_NATURES = ['50', '55']
*/

export const accountsNaturesExcludedForOperations = {}
